<template>
  <div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{ text }}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>

    <v-toolbar flat color="white">
      <v-tabs div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          @click="
            showNewApplications = true;
            showResolvedApplications = false;
          "
        >
          Pending
          <v-chip color="primary" class="white--text">{{ pendingTotalItems }}</v-chip>
        </v-tab>
        <v-tab
          @click="
            showNewApplications = false;
            showResolvedApplications = true;
          "
        >
          Completed
          <v-chip color="success" class="white--text">{{ resolvedTotalItems }}</v-chip>
        </v-tab>
        <!-- <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>-->
      </v-tabs>
    </v-toolbar>
    <v-toolbar flat color="white">
      <div>
        <applicationpagemodal @submitComplete="fetchAfterOrderAdd()"></applicationpagemodal>
      </div>
      <v-btn class="white--text" :color="$store.state.currentOrg.org.primaryColour" round @click="exportCompletedData()"
        >Export Completed Orders</v-btn
      >

      <v-spacer></v-spacer>
      <v-text-field
        v-if="showNewApplications"
        v-model="pendingSearch"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
        v-on:keyup.enter="
          $router.push({
            name: $route.name,
            query: {
              pendingOffset: $route.query.pendingOffset,
              resolvedOffset: $route.query.resolvedOffset,
              pendingSearch: pendingSearch,
              resolvedSearch: $route.query.resolvedSearch,
              records: $route.query.records,
            },
          })
        "
      ></v-text-field>
      <v-text-field
        v-if="showResolvedApplications"
        v-model="resolvedSearch"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
        v-on:keyup.enter="
          $router.push({
            name: $route.name,
            query: {
              pendingOffset: $route.query.pendingOffset,
              resolvedOffset: $route.query.resolvedOffset,
              pendingSearch: $route.query.pendingSearch,
              resolvedSearch: resolvedSearch,
              records: $route.query.records,
            },
          })
        "
      ></v-text-field>
    </v-toolbar>

    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <v-flex v-if="showNewApplications">
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :rows-per-page-items="[$route.query.records]"
        :loading="isLoading"
        :items="newApplications"
        item-key="id"
        disable-initial-sort
        align-center
        style="cursor: pointer"
        hide-actions
        :pagination.sync="pendingPagination"
      >
        <template v-slot:items="props">
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
            <v-chip v-if="props.item.type == 'Order'" small class="white--text" color="light-green">Order</v-chip>
            <v-chip v-else-if="props.item.type == 'Feasibility'" small class="white--text" color="blue"
              >Feasibility</v-chip
            >
            <v-chip v-else-if="props.item.type == 'Interest'" small class="white--text" color="orange">Interest</v-chip>
            <v-chip v-else-if="props.item.type == 'Proposal'" small class="white--text" color="purple">Proposal</v-chip>
          </td>

          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
            {{ props.item.id }}
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
            {{ formatDate(props.item.createdAt) }}
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
            {{ formatDate(props.item.updatedAt) }}
          </td>

          <td v-if="props.item.locationId" class="text-xs-center" @click="routerLinkToDetails(props.item)">
            {{ props.item.location.locationDescription }}
          </td>
          <td v-else class="text-xs-center" @click="routerLinkToDetails(props.item)">
            <!-- {{ props.item.streetNumber }} {{ props.item.streetName }} -->
            {{ formattedAddress(props.item) }}
          </td>
          <td
            v-if="props.item.supplierOrganisationId === $store.state.currentOrg.org.id"
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >
            Network Operator
          </td>
          <td
            v-else-if="props.item.customerOrganisationId === $store.state.currentOrg.org.id"
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >
            ISP
          </td>
          <td
            v-else-if="props.item.organisationId === $store.state.currentOrg.org.id"
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >
            Owner
          </td>
          <!-- <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.invoiceNumber!==null">
        {{props.item.invoiceNumber}}
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.invoiceNumber!==null">
        <v-icon v-if="props.item.isPaid" color="green">done</v-icon>
        <v-icon v-if="!props.item.isPaid" color="red">not_interested</v-icon>
        </td>-->
          <!-- <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        
        </td>-->
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
            v-if="props.item.packagesIspId && props.item.ispVerified && props.item.ispAccepted"
          >
            <v-chip color="success" class="white--text">Accepted</v-chip>
          </td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
            v-else-if="props.item.packagesIspId && props.item.ispVerified && !props.item.ispAccepted"
          >
            <v-chip color="red" class="white--text">Rejected</v-chip>
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else-if="props.item.packagesIspId">
            <v-chip color="warning" class="white--text">Pending</v-chip>
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
            <v-chip color="grey" class="white--text">N/A</v-chip>
          </td>
          <td
            @mouseover="selectItem(props.item)"
            @mouseleave="selectedItem = {}"
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >
            <v-menu
              v-if="
                openTickets.length > 0 &&
                  openTickets.filter(function(el) {
                    if (el.rows && el.rows[0]) {
                      return el.rows[0].applicationId === props.item.id;
                    }
                  })[0]
              "
              open-on-hover
              top
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip v-bind="attrs" v-on="on" color="success" class="white--text"
                  >{{
                    openTickets.filter(function(el) {
                      if (el.rows && el.rows[0]) {
                        return el.rows[0].applicationId === props.item.id;
                      }
                    })[0].count
                  }}
                </v-chip>
              </template>

              <v-card
                v-if="
                  props.item === selectedItem &&
                    listTickets &&
                    openTickets.filter(function(el) {
                      if (el.rows && el.rows[0]) {
                        return el.rows[0].applicationId === props.item.id;
                      }
                    })[0]
                "
                flat
              >
                <v-flex v-for="ticket in listTickets" :key="ticket.id">
                  <v-card v-on="on" hover flat width="300px">
                    <v-layout justify-center>
                      <v-flex xs6 text-xs-left>
                        <h4 class="mx-1 grey--text font-weight-bold">ID:</h4>
                      </v-flex>
                      <v-flex xs6 text-xs-left>
                        <h4 class=" grey--text font-weight-light">{{ ticket.id }}</h4>
                      </v-flex>
                    </v-layout>
                    <v-layout justify-center v-if="ticket.ticketCategoryItem">
                      <v-flex xs6 text-xs-left>
                        <h4 class="mx-1 grey--text font-weight-bold">Subcategory:</h4>
                      </v-flex>
                      <v-flex xs6 text-xs-left>
                        <h4 class="grey--text font-weight-light">{{ ticket.ticketCategoryItem.name }}</h4>
                      </v-flex>
                    </v-layout>
                    <v-layout justify-center align-center>
                      <v-flex xs6 text-xs-left>
                        <h4 class="mx-1 grey--text font-weight-bold">Status:</h4>
                      </v-flex>
                      <v-flex xs6 text-xs-left>
                        <h4 class="grey--text">
                          <v-chip
                            small
                            :class="`${ticket.currentStatus.replace(/\s/g, '').toLowerCase()} white--text`"
                            >{{ ticket.currentStatus }}</v-chip
                          >
                        </h4>
                      </v-flex>
                    </v-layout>
                    <v-layout justify-center align-center>
                      <v-flex xs6 text-xs-left>
                        <h4 class="mx-1 grey--text font-weight-bold">Due date:</h4>
                      </v-flex>
                      <v-flex xs6 text-xs-left>
                        <v-span class="grey--text">{{ formatDate(ticket.dueDate) }}</v-span>
                      </v-flex>
                    </v-layout>
                  </v-card>
                  <v-divider></v-divider>
                </v-flex>
              </v-card>
            </v-menu>
            <v-chip v-else color="grey" class="white--text">0</v-chip>
          </td>

          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isInstallVerified">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>

          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isDeviceVerified">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>

          <!-- <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isPackageVerified">
        <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <v-icon color="red">not_interested</v-icon>
        </td>-->

          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isContactVerified">
            <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
            <v-icon color="red">not_interested</v-icon>
          </td>
          <td
            class="text-xs-center"
            v-if="props.item.primaryContactTitle !== null"
            @click="routerLinkToDetails(props.item)"
          >
            {{
              props.item.primaryContactTitle +
                " " +
                props.item.primaryContactFirstname +
                " " +
                props.item.primaryContactLastname
            }}
          </td>
          <td class="text-xs-center" v-else @click="routerLinkToDetails(props.item)">
            {{ props.item.primaryContactFirstname + " " + props.item.primaryContactLastname }}
          </td>

          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
            {{ props.item.primaryContactMobileNumber }}
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
            {{ props.item.primaryContactEmailAddress }}
          </td>
          <td v-if="props.item.notes" class="text-xs-center" @click="routerLinkToDetails(props.item)">
            {{ props.item.notes.comment + " " + formatDateTime(props.item.notes.createdAt) }}
          </td>
          <td v-else class="text-xs-center" @click="routerLinkToDetails(props.item)"></td>
        </template>
        <template v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template
        >
      </v-data-table>
      <div class="text-xs-center pt-2 white" :key="$route.query.pendingOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="pendingPage"
              :length="Math.ceil(pendingTotalItems / $route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
    <v-flex v-if="showResolvedApplications">
      <v-data-table
        :key="key"
        :headers="resolvedHeaders"
        class="elevation-1"
        :rows-per-page-items="[$route.query.records]"
        :loading="isLoading"
        :items="resolvedApplications"
        item-key="id"
        disable-initial-sort
        align-center
        style="cursor: pointer"
        hide-actions
        :pagination.sync="resolvedPagination"
      >
        <template v-slot:items="props">
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
            <v-chip v-if="props.item.type == 'Order'" small class="white--text" color="light-green">Order</v-chip>
            <v-chip v-else-if="props.item.type == 'Feasibility'" small class="white--text" color="blue"
              >Feasibility</v-chip
            >
            <v-chip v-else-if="props.item.type == 'Interest'" small class="white--text" color="orange">Interest</v-chip>
            <v-chip v-else-if="props.item.type == 'Proposal'" small class="white--text" color="purple">Proposal</v-chip>
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
            {{ props.item.id }}
          </td>
          <td v-if="props.item.locationId" class="text-xs-center" @click="routerLinkToDetails(props.item)">
            {{ props.item.location.locationDescription }}
          </td>
          <td v-else class="text-xs-center" @click="routerLinkToDetails(props.item)">
            {{ props.item.streetNumber }} {{ props.item.streetName }}
          </td>
          <td
            v-if="props.item.supplierOrganisationId === $store.state.currentOrg.org.id"
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >
            Network Operator
          </td>
          <td
            v-else-if="props.item.customerOrganisationId === $store.state.currentOrg.org.id"
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >
            ISP
          </td>
          <td
            v-else-if="props.item.organisationId === $store.state.currentOrg.org.id"
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >
            Owner
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isApproved">
            <v-chip class="green white--text">Approved</v-chip>
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
            <v-chip class="red white--text">Denied</v-chip>
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
            {{ formatDate(props.item.createdAt) }}
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
            {{ formatDate(props.item.resolvedDate) }}
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.resolvedById">
            {{ props.item.resolvedBy.name }} {{ props.item.resolvedBy.surname }}
          </td>
          <td v-else></td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)">
            {{ props.item.deniedReason }}
          </td>
          <td
            v-if="props.item.primaryContactId !== null"
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >
            {{ props.item.primaryContact.name }}
            {{ props.item.primaryContact.surname }}
          </td>
          <td class="text-xs-center" v-else></td>
          <td
            v-if="props.item.primaryContactId !== null"
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >
            {{ props.item.primaryContact.mobileNumber }}
          </td>
          <td class="text-xs-center" v-else></td>
          <td
            v-if="props.item.primaryContactId !== null"
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >
            {{ props.item.primaryContact.emailAddress }}
          </td>
          <td class="text-xs-center" v-else></td>
          <!-- <td v-if="props.item.primaryContactId!==null" class="text-xs-center" @click="routerLinkToDetails(props.item)">
        {{props.item.primaryContact.idNumber}}
        </td>
          <td class="text-xs-center" v-else></td>-->
        </template>
        <template v-slot:pageText="props"
          >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template
        >
      </v-data-table>
      <div class="text-xs-center pt-2 white" :key="$route.query.resolvedOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="resolvedPage"
              :length="Math.ceil(resolvedTotalItems / $route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import applicationPageModal from "@/components/ApplicationPageModal.vue";
export default {
  components: {
    applicationpagemodal: applicationPageModal,
  },
  data() {
    return {
      listTickets: [],
      selectedItem: {},
      initialPendingLoad: 0,
      initialResolvedLoad: 0,
      tempSortBy: null,
      tempDescending: true,
      key: 0,
      showDetails: true,
      showNewApplications: true,
      showResolvedApplications: false,
      isLoading: false,
      expand: false,
      search: "",
      dialog: false,
      snackbar: false,
      pendingPage: 1,
      pendingPagination: { sortBy: "updatedAt", descending: true },
      pendingSearch: "",
      pendingTotalItems: 0,
      resolvedPage: 1,
      resolvedPagination: { sortBy: "createdAt", descending: true },
      resolvedSearch: "",
      resolvedTotalItems: 0,
      text: "",
      y: "top",
      allVlans: [],
      newApplications: [],
      openTickets: [],
      newDialog: false,
      // resolvedPagination: {
      //   descending: true,
      //   activeTabName: "",
      //   sortBy: "resolvedDate"
      // },
      pagination: {
        descending: true,
        activeTabName: "",
        sortBy: "createdAt",
      },
      tabs: [
        { name: "newApplications", displayName: "Pending" },
        { name: "resolvedApplications", displayName: "Resolved" },
      ],
      resolvedHeaders: [
        {
          text: "Type",
          align: "center",
          value: "type",
          sortable: false,
        },
        {
          text: "ID",
          align: "center",
          value: "id",
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription",
          sortable: false,
        },
        {
          text: "Role",
          align: "center",
          value: "role",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: "Submitted",
          align: "center",
          value: "createdAt",
        },
        {
          text: "Resolved Date",
          align: "center",
          value: "resolvedDate",
        },
        {
          text: "Resolved By",
          align: "center",
          value: "resolvedBy.name",
          sortable: false,
        },
        {
          text: "Comment",
          align: "center",
          value: "deniedReason",
          sortable: false,
        },
        {
          text: "Contact Name",
          align: "center",
          value: "primaryContactName",
          sortable: false,
        },
        {
          text: "Mobile Number",
          align: "center",
          value: "primaryContactMobileNumber",
          sortable: false,
        },
        {
          text: "Email Address",
          align: "center",
          value: "primaryContactEmailAddress",
          sortable: false,
        },
      ],
      headers: [
        {
          text: "Type",
          align: "center",
          value: "type",
          sortable: false,
        },
        {
          text: "ID",
          align: "center",
          value: "id",
        },
        {
          text: "Submitted",
          align: "center",
          value: "createdAt",
        },
        {
          text: "Last Updated",
          align: "center",
          value: "updatedAt",
        },

        {
          text: "Location",
          align: "center",
          value: "location.locationDescription",
          sortable: false,
        },
        {
          text: "Role",
          align: "center",
          value: "role",
          sortable: false,
        },
        // {
        //   text: "Invoice",
        //   align: "center",
        //   value: "invoiceNumber"
        // },
        // {
        //   text: "Invoice Paid",
        //   align: "center",
        //   value: "isPaid"
        // },
        {
          text: "ISP Acceptance",
          align: "center",
          value: "ispVerified",
          sortable: false,
        },
        {
          text: "Open Tickets",
          align: "center",
          value: "openTickets",
          sortable: false,
        },
        {
          text: "Install Verified",
          align: "center",
          value: "isInstallVerified",
          sortable: false,
        },
        {
          text: "Device Verified",
          align: "center",
          value: "isDeviceVerified",
          sortable: false,
        },
        {
          text: "Contact Verified",
          align: "center",
          value: "isContactVerified",
          sortable: false,
        },
        {
          text: "Contact Name",
          align: "center",
          value: "primaryContactFirstname",
          sortable: false,
        },
        {
          text: "Mobile Number",
          align: "center",
          value: "primaryContactMobileNumber",
          sortable: false,
        },
        {
          text: "Email Address",
          align: "center",
          value: "primaryContactEmailAddress",
          sortable: false,
        },
        {
          text: "Latest Note",
          align: "center",
          value: "notes",
          sortable: false,
        },
      ],
      totalApplications: 0,
      applications: [],
    };
  },

  computed: {
    pages() {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 0;
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    },
   
  },
  watch: {
    "pendingPagination.sortBy": {
      immediate: true,
      handler(value) {
        if (value !== "" && value != null && this.initialPendingLoad > 0) {
          this.pendingPage = 1;
          this.initialPendingLoad++;
          Api()
            .get("/applications/all/active", {
              params: {
                offset: "0",
                search: this.$route.query.pendingSearch,
                records: this.$route.query.records,
                sortBy: this.pendingPagination.sortBy,
                descending: this.pendingPagination.descending ? "DESC" : "ASC",
              },
            })
            .then((response) => {
              this.newApplications = response.data.result;
              this.openTickets = response.data.openTickets;

              this.pendingTotalItems = response.data.count;
              //this.pendingPagination={}
              this.isLoading = false;
            });
        }
      },
    },
    "pendingPagination.descending": {
      immediate: true,
      handler(value) {
        if (value !== "" && value != null && this.initialPendingLoad > 0) {
          this.pendingPage = 1;
          this.initialPendingLoad++;
          Api()
            .get("/applications/all/active", {
              params: {
                offset: "0",
                search: this.$route.query.pendingSearch,
                records: this.$route.query.records,
                sortBy: this.pendingPagination.sortBy,
                descending: this.pendingPagination.descending ? "DESC" : "ASC",
              },
            })
            .then((response) => {
              this.newApplications = response.data.result;
              this.openTickets = response.data.openTickets;
              this.pendingTotalItems = response.data.count;
              //this.pendingPagination={}
              this.isLoading = false;
            });
        }
      },
    },
    "resolvedPagination.sortBy": {
      immediate: true,
      handler(value) {
        if (value !== "" && value != null && this.initialResolvedLoad > 0) {
          this.resolvedPage = 1;
          this.initialResolvedLoad++;
          Api()
            .get("/applications/all/resolved", {
              params: {
                offset: "0",
                search: this.$route.query.resolvedSearch,
                records: this.$route.query.records,
                sortBy: this.resolvedPagination.sortBy,
                descending: this.resolvedPagination.descending ? "DESC" : "ASC",
              },
            })
            .then((response) => {
              this.resolvedApplications = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.key++;
              this.isLoading = false;
            });
        }
      },
    },
    "resolvedPagination.descending": {
      immediate: true,
      handler(value) {
        if (value !== "" && value != null && this.initialResolvedLoad > 0) {
          this.resolvedPage = 1;
          this.initialResolvedLoad++;
          Api()
            .get("/applications/all/resolved", {
              params: {
                offset: "0",
                search: this.$route.query.resolvedSearch,
                records: this.$route.query.records,
                sortBy: this.resolvedPagination.sortBy,
                descending: this.resolvedPagination.descending ? "DESC" : "ASC",
              },
            })
            .then((response) => {
              this.resolvedApplications = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.key++;
              //this.resolvedPagination={}
              this.isLoading = false;
            });
        }
      },
    },
    // Pending Applications
    "$route.query.pendingSearch": {
      immediate: true,
      handler(value) {
        this.isLoading = true;
        if (this.$route.query.pendingSearch && value !== "" && value != null && this.initialPendingLoad > 0) {
          this.pendingPage = 1;
          this.initialPendingLoad++;
          Api()
            .get("/applications/all/active", {
              params: {
                search: this.$route.query.pendingSearch,
                offset: "0",
                records: this.$route.query.records,
                sortBy: this.pendingPagination.sortBy,
                descending: this.pendingPagination.descending ? "DESC" : "ASC",
              },
            })
            .then((response) => {
              this.newApplications = response.data.result;
              this.openTickets = response.data.openTickets;
              this.pendingTotalItems = response.data.count;
              this.isLoading = false;
            });
        } else if (this.$route.query.pendingOffset != "undefined" && this.initialPendingLoad > 0) {
          this.initialPendingLoad++;
          Api()
            .get("/applications/all/active", {
              params: {
                offset: this.$route.query.pendingOffset,
                records: this.$route.query.records,
                sortBy: this.pendingPagination.sortBy,
                descending: this.pendingPagination.descending ? "DESC" : "ASC",
              },
            })
            .then((response) => {
              this.newApplications = response.data.result;
              this.openTickets = response.data.openTickets;
              this.pendingTotalItems = response.data.count;
              this.isLoading = false;
            });
        }
      },
    },
    "$route.query.pendingOffset": {
      immediate: true,
      handler(value) {
        this.isLoading = true;
        if (
          value !== "" &&
          value != null &&
          this.$route.query.pendingSearch &&
          this.$route.query.pendingSearch != "" &&
          this.$route.query.pendingSearch !== null &&
          this.$route.query.pendingSearch !== "undefined" &&
          this.initialPendingLoad > 0
        ) {
          this.initialPendingLoad++;
          Api()
            .get("/applications/all/active", {
              params: {
                search: this.$route.query.pendingSearch,
                offset: this.$route.query.pendingOffset,
                records: this.$route.query.records,
                sortBy: this.pendingPagination.sortBy,
                descending: this.pendingPagination.descending ? "DESC" : "ASC",
              },
            })
            .then((response) => {
              this.newApplications = response.data.result;
              this.openTickets = response.data.openTickets;
              this.pendingTotalItems = response.data.count;
              this.isLoading = false;
            });
        } else if (value != null && value != "undefined") {
          this.initialPendingLoad++;
          Api()
            .get("/applications/all/active", {
              params: {
                offset: this.$route.query.pendingOffset,
                records: this.$route.query.records,
                sortBy: this.pendingPagination.sortBy,
                descending: this.pendingPagination.descending ? "DESC" : "ASC",
              },
            })
            .then((response) => {
              this.newApplications = response.data.result;
              this.openTickets = response.data.openTickets;
              this.pendingTotalItems = response.data.count;
              // this.key++
              this.isLoading = false;
            });
        }
      },
    },
    pendingPage(value) {
      // this.pendingPagination.page = this.pendingPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.pendingSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: this.$route.query.resolvedOffset,
              pendingOffset: (value - 1) * this.$route.query.records,
              resolvedSearch: this.$route.query.activeSearch,
              pendingSearch: this.$route.query.pendingSearch,
            },
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: this.$route.query.resolvedOffset,
              pendingOffset: (value - 1) * this.$route.query.records,
              resolvedSearch: this.$route.query.activeSearch,
            },
          });
        }
      }
    },

    // Resolved
    "$route.query.resolvedSearch": {
      immediate: true,
      handler(value) {
        this.isLoading = true;
        if (this.$route.query.resolvedSearch && value !== "" && value != null && this.initialResolvedLoad > 0) {
          this.resolvedPage = 1;
          this.initialResolvedLoad++;
          Api()
            .get("/applications/all/resolved", {
              params: {
                search: this.$route.query.resolvedSearch,
                offset: "0",
                records: this.$route.query.records,
                sortBy: this.resolvedPagination.sortBy,
                descending: this.resolvedPagination.descending ? "DESC" : "ASC",
              },
            })
            .then((response) => {
              this.resolvedApplications = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.key++;
              this.isLoading = false;
            });
        } else if (this.$route.query.resolvedOffset != "undefined" && this.initialResolvedLoad > 0) {
          this.initialResolvedLoad++;
          Api()
            .get("/applications/all/resolved", {
              params: {
                offset: this.$route.query.resolvedOffset,
                records: this.$route.query.records,
                sortBy: this.resolvedPagination.sortBy,
                descending: this.resolvedPagination.descending ? "DESC" : "ASC",
              },
            })
            .then((response) => {
              this.resolvedApplications = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.key++;
              this.isLoading = false;
            });
        }
        this.key++;
      },
    },
    "$route.query.resolvedOffset": {
      immediate: true,
      handler(value) {
        this.isLoading = true;
        if (
          value !== "" &&
          value != null &&
          this.$route.query.resolvedSearch &&
          this.$route.query.resolvedSearch != "" &&
          this.$route.query.resolvedSearch !== null &&
          this.$route.query.resolvedSearch !== "undefined" &&
          this.initialResolvedLoad > 0
        ) {
          Api()
            .get("/applications/all/resolved", {
              params: {
                search: this.$route.query.resolvedSearch,
                offset: this.$route.query.resolvedOffset,
                records: this.$route.query.records,
                sortBy: this.resolvedPagination.sortBy,
                descending: this.resolvedPagination.descending ? "DESC" : "ASC",
              },
            })
            .then((response) => {
              this.resolvedApplications = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.key++;
              this.isLoading = false;
            });
        } else if (value != null && value != "undefined") {
          this.initialResolvedLoad++;
          Api()
            .get("/applications/all/resolved", {
              params: {
                offset: this.$route.query.resolvedOffset,
                records: this.$route.query.records,
                sortBy: this.resolvedPagination.sortBy,
                descending: this.resolvedPagination.descending ? "DESC" : "ASC",
              },
            })
            .then((response) => {
              this.resolvedApplications = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.key++;
              this.isLoading = false;
            });
        }
        this.key++;
      },
    },
    resolvedPage(value) {
      //this.resolvedPagination.page = this.resolvedPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.resolvedSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              resolvedSearch: this.$route.query.resolvedSearch,
              pendingSearch: this.$route.query.pendingSearch,
            },
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              pendingSearch: this.$route.query.pendingSearch,
            },
          });
        }
      }
    },
  },

  async created() {
    this.initialize();
  },

  methods: {
    selectItem(item) {
      this.selectedItem = item;
      if (
        this.openTickets.filter(function(el) {
          if (el.rows && el.rows[0]) {
            return el.rows[0].applicationId === item.id;
          }
        }).length > 0
      ) {
        this.listTickets = this.openTickets.filter(function(el) {
          if (el.rows && el.rows[0]) {
            return el.rows[0].applicationId === item.id;
          }
        })[0].rows;
      }
    },
    exportCompletedData() {
      Api()
        .get("/applications/resolved/export")
        .then((response) => {
          var hiddenElement = document.createElement("a");
          hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(response.data);
          hiddenElement.target = "_blank";
          hiddenElement.download = "completed_orders.csv";
          hiddenElement.click();
        });
    },
    fetchAfterOrderAdd() {
      this.load = true;
      this.setActiveTabName("newApplications");
      this.pendingPage = 1;
      Api()
        .get("/applications/all/active", {
          params: {
            search: this.$route.query.pendingSearch,
            offset: this.$route.query.pendingOffset,
            records: this.$route.query.records,
            sortBy: this.pendingPagination.sortBy,
            descending: this.pendingPagination.descending ? "DESC" : "ASC",
          },
        })
        .then((response) => {
          this.newApplications = response.data.result;
          this.openTickets = response.data.openTickets;
          this.pendingTotalItems = response.data.count;
          this.isLoading = false;
        });
    },
    async routerLinkToDetails(item) {
      if (item.type == "Order" && item.supplierOrganisationId === this.$store.state.currentOrg.org.id) {
        let route = await this.$store.state.currentOrg.org.permissions.filter(function(el) {
          return el.url === "/applications/:applicationId";
        });
        await this.$store.dispatch("setCurrentRoute", route[0]);
        this.editedItem = Object.assign({}, item);
        this.$router.push({ path: "/applications/" + this.editedItem.id });
      } else if (item.type != "Order" && item.supplierOrganisationId === this.$store.state.currentOrg.org.id) {
        let route = await this.$store.state.currentOrg.org.permissions.filter(function(el) {
          return el.url === "/applications/lead/:applicationId";
        });
        await this.$store.dispatch("setCurrentRoute", route[0]);
        this.editedItem = Object.assign({}, item);
        this.$router.push({ path: "/applications/lead/" + this.editedItem.id });
      } else if (item.customerOrganisationId === this.$store.state.currentOrg.org.id) {
        let route = await this.$store.state.currentOrg.org.permissions.filter(function(el) {
          return el.url === "/ispApplications/:applicationId";
        });
        await this.$store.dispatch("setCurrentRoute", route[0]);
        this.editedItem = Object.assign({}, item);
        this.$router.push({ path: "/ispApplications/" + this.editedItem.id });
      } else if (item.organisationId === this.$store.state.currentOrg.org.id) {
        let route = await this.$store.state.currentOrg.org.permissions.filter(function(el) {
          return el.url === "/virtualOwnerApplication/:applicationId";
        });
        await this.$store.dispatch("setCurrentRoute", route[0]);
        this.editedItem = Object.assign({}, item);
        this.$router.push({ path: "/virtualOwnerApplication/" + this.editedItem.id });
      }
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
     formattedAddress(val){
      let address = ''
      if(val.unitNo){
        address += 'Unit '+val.unitNo +', '
      }
      if(val.floorNo){
        address += 'Floor '+val.floorNo +', '
      }
      if(val.building){
        address += val.building +', '
      }
      if(val.streetNumber){
        address += val.streetNumber +' '
      }
      if(val.streetName){
        address += val.streetName +', '
      }
      if(val.suburb){
        address += val.suburb +', '
      }
      if(val.town){
        address +=val.town +', '
      }
      if(val.province){
        address += val.province +', '
      }
      if(val.country){
        address += val.country
      }
      if(val.postalCode){
        address +=  ' ' + val.postalCode
      }
      return address
    },
    initialize() {
      let route = this.$store.state.currentOrg.org.permissions.filter(function(el) {
        return el.url === "/applications";
      });
      if (route.length > 0) {
        this.$store.dispatch("setCurrentRoute", route[0]);
        if (this.authRead(this.$store.state.currentRoute) === true) {
          this.$router.push({
            name: this.$route.name,
            query: {
              pendingOffset: "0",
              resolvedOffset: "0",
              records: "15",
            },
          });
          this.showNewApplications = true;
        }
      } else {
        this.$router.push({ name: "SplashPage" });
      }
    },
  },
};
</script>
